import React from 'react';
import logoSvg from 'src/assets/logo_pride.svg';

import {
  FileTextIcon,
  EyeIcon,
  DownloadIcon,
  Content,
  Footer,
  H1,
  PageContainer,
  Logo,
  Header,
  PolicyCard,
  FileIcon,
  PolicyInfo,
  PolicyTitle,
  PolicyMeta,
  PdfBadge,
  ActionContainer,
  ViewButton,
  DownloadButton,
} from './style';

const CompanyPolicy: React.FC = () => (
  <PageContainer>
    <Header>
      <Logo src={logoSvg} alt="Pride Global logo" />
    </Header>

    <Content>
      <H1>Pride Global & Subsidiaries - Policy Documents</H1>

      <PolicyCard>
        <FileIcon>
          <FileTextIcon />
        </FileIcon>

        <PolicyInfo>
          <PolicyTitle>California Time Entry Policy</PolicyTitle>

          <PolicyMeta>
            <PdfBadge>PDF</PdfBadge>
            <span>266 KB</span>
            <span className="separator">•</span>
            <span>Updated Sept 2026</span>
          </PolicyMeta>
        </PolicyInfo>

        <ActionContainer>
          <ViewButton href="/pdf/California_Time Entry Policy.pdf" target="_blank" rel="noopener noreferrer">
            <EyeIcon />
            <span>View</span>
          </ViewButton>

          <DownloadButton href="/pdf/California_Time Entry Policy.pdf" download="California_Time Entry Policy.pdf">
            <DownloadIcon />
            <span>Download</span>
          </DownloadButton>
        </ActionContainer>
      </PolicyCard>
    </Content>
    <Footer>Pride Global</Footer>
  </PageContainer>
);

export default CompanyPolicy;
